// FMP API Configuration
export const FMP_CONFIG = {
  baseUrl: process.env.REACT_APP_FMP_BASE_URL,
  wsUrl: process.env.REACT_APP_FMP_WS_URL,
  
  // Cache configuration
  cache: {
    enabled: true,
    ttl: 60000, // 1 minute
  },

  // WebSocket configuration
  websocket: {
    reconnectInterval: 5000,
    maxReconnectAttempts: 5,
    heartbeatInterval: 30000,
  },
};

// Validate configuration
export const validateConfig = () => {
  if (!FMP_CONFIG.apiKey) {
    console.error('FMP API Key is missing. Please set REACT_APP_FMP_API_KEY in .env');
    return false;
  }
  return true;
};

export default FMP_CONFIG;